export default __webpack_public_path__ + "static/media/manny-circle.49c6fcdb.png";